<template>
  <page-wrapper :title="title" :has-pad="true">
    <div class="mb-4">
      <package-selector v-model="form" :is-action-edit="true"></package-selector>
    </div>
    <div class="text-end">
      <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
    </div>
  </page-wrapper>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import PackageSelector from "../../collections/components/PackageSelector";

export default {
  components: {
    PageWrapper,
    ScButton,
    PackageSelector
  },
  data() {
    const title = "จัดลำดับการแสดงผล";
    const form = [];

    return {
      title,
      form
    };
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupForm();
    },
    async setupForm() {
      const form = await this.fetchOrderingPackages();

      this.form = form;
    },
    async fetchOrderingPackages() {
      try {
        const response = await baanRueJaiClient.admin.subscriptions.recommend_packages.getOrder();

        return response.data.result.map(item => {
          const {
            id,
            name,
            price,
            billing_cycle: billingCycle,
            detail,
            service_ids: serviceIds,
            project_ids: projectIds,
            image_url: imageUrl,
            target
          } = item;

          return {
            id: id.toString(),
            name,
            target,
            price,
            billingCycle,
            detail,
            serviceCount: serviceIds.length,
            projectCount: (projectIds || []).length,
            imageUrl
          };
        });
      } catch (err) {
        if (err.response && err.response.status === 500) {
          return [];
        }

        throw err;
      }
    },
    async handleClickSave() {
      const params = { ids: this.form.map(({ id }) => +id) };

      try {
        await baanRueJaiClient.admin.subscriptions.recommend_packages.postOrder(
          params
        );

        this.$message.success("จัดลำดับเรียบร้อย");
      } catch (err) {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.editor {
  margin-bottom: $space;
}
</style>
